<template>
  <div class="navBarContainer">
    <b-navbar toggleable="lg" type="light" variant="light" ref="navBar">
      <b-navbar-brand>
        <router-link to="/" class="brandAnchor">
          <img
            src="images/small_logo.png"
            class="navBarLogo"
            :class="{ smallLogo: isMobile }"
          />
          <span class="ibcText">
            <p>International Business Center</p>
            <p>Since 1986</p>
          </span>
        </router-link>
      </b-navbar-brand>

      <b-navbar-toggle target="nav-collapse"></b-navbar-toggle>

      <b-collapse id="nav-collapse" is-nav>
        <b-navbar-nav class="ml-auto">
          <b-nav-item>
            <router-link to="/introduction">{{
              $t("navBar.introduction")
            }}</router-link>
          </b-nav-item>
          <b-nav-item>
            <router-link to="/servicedoffice">{{
              $t("navBar.servicedoffice")
            }}</router-link>
          </b-nav-item>
          <b-nav-item>
            <router-link to="/virtualoffice">{{
              $t("navBar.virtualoffice")
            }}</router-link>
          </b-nav-item>
          <b-nav-item>
            <router-link to="/professionalservices">{{
              $t("navBar.professionalservices")
            }}</router-link>
          </b-nav-item>
          <b-nav-item>
            <router-link to="/contactus">{{
              $t("navBar.contactus")
            }}</router-link>
          </b-nav-item>

          <b-dropdown right>
            <template v-slot:button-content>
              <font-awesome-icon
                :icon="['fas', 'language']"
                size="lg"
                :style="{ color: 'white' }"
                fixed-width
              />
            </template>

            <b-dropdown-item @click="changeLocale('en')"
              >English</b-dropdown-item
            >
            <b-dropdown-item @click="changeLocale('zh')">中文</b-dropdown-item>
          </b-dropdown>

          <b-navbar-brand>
            <img
              src="images/caring-company-logo.png"
              class="caringCompanyLogo"
            />
          </b-navbar-brand>
        </b-navbar-nav>
      </b-collapse>
    </b-navbar>
  </div>
</template>

<script>
export default {
  data() {
    return {
      isMobile: window.innerWidth <= 450 ? true : false
    };
  },
  methods: {
    handleScroll() {
      let navBar = this.$refs.navBar;
      let sticky = navBar.offsetTop;

      if (window.pageYOffset >= sticky) {
        navBar.classList.add("sticky");
      } else {
        navBar.classList.remove("sticky");
      }
    },
    changeLocale(locale) {
      if (locale === "en") {
        this.$i18n.locale = "en_US";
        localStorage.setItem("locale", "en_US");
      } else {
        this.$i18n.locale = "zh_HK";
        localStorage.setItem("locale", "zh_HK");
      }
    }
  },
  created() {
    window.addEventListener("scroll", this.handleScroll);

    window.addEventListener("resize", function() {
      this.isMobile = window.innerWidth <= 450 ? true : false;
      let tar = document.querySelector(".navBarLogo");
      if (tar.classList.contains("smallLogo")) {
        tar.classList.remove("smallLogo");
      } else {
        tar.classList.add("smallLogo");
      }
    });
  },
  mounted() {},
  destroyed() {
    window.removeEventListener("scroll", this.handleScroll);
  }
};
</script>

<style scoped>
.navBarLogo {
  height: 5rem;
}

.smallLogo {
  height: 2.5rem;
}

.ibcText {
  font-size: 1rem;
}

.ibcText p {
  margin: 0;
}

.brandAnchor {
  display: flex;
  justify-content: center;
  align-items: center;
}

.caringCompanyLogo {
  margin-left: 1rem;
  height: 1.5rem;
}

.navbar-brand {
  display: inline-block;
  font-size: 1.25rem;
  line-height: inherit;
  white-space: nowrap;
}

@media only screen and (max-width: 600px) {
  .navbar-brand {
    font-size: 1rem;
  }
}

.navbar-light .navbar-nav .nav-link {
  color: black;
}

.navbar-light .navbar-nav .nav-link:hover {
  color: grey;
}

.bg-light {
  background-color: white !important;
}

.sticky {
  position: fixed;
  top: 0;
  width: 100%;
  z-index: 999;
}

a {
  color: black;
  text-decoration: none;
}

a:hover {
  color: #69a8ec;
  text-decoration: none;
}

.router-link-active {
  color: #007bff;
}

.ibcText {
  margin-left: 0.5rem;
  color: #003e7d;
  font-family: Optima, Segoe, Segoe UI, Candara, Calibri, Arial, sans-serif;
}
</style>
